import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    guest: string;
    new: string;
    member: string;
    contentAdmin: string;
    owner: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Guest label */
            guest: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UserInputToken.guest?c=3dszhu21ezltw", defaultMessage: "Guest" }));
                },
                enumerable: true,
                configurable: true
            },
            /** New label */
            new: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UserInputToken.new?c=jqvjcamk7vs3", defaultMessage: "New" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Member label */
            member: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UserInputToken.member?c=m9y5ixy73rk5", defaultMessage: "Member" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Content Admin label */
            contentAdmin: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UserInputToken.contentAdmin?c=1jp8z6lcsvipj", defaultMessage: "Content Admin" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Owner label */
            owner: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UserInputToken.owner?c=q2yk8jehyit6", defaultMessage: "Owner" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
